import { createSlice } from '@reduxjs/toolkit'
import { modifyStateAction, updateStateAction } from '../fns'

export const createGenericSlice = ({ name, initialState, reducers, extraReducers }) => {
  return createSlice({
    name,
    initialState,
    reducers: {
      modifyCalculation: modifyStateAction,
      updateCalculation: updateStateAction,
      modifyInput: modifyStateAction,
      updateInput: updateStateAction,
      ...reducers,
    },
    extraReducers,
  })
}
